import React, { useEffect, useState } from "react";
import "./explore.scss";

//Icona
//import FilterListIcon from '@mui/icons-material/FilterList';

//Componenti
import HeaderBar from "../../components/headerBar/HeaderBar";
import AssociationBox from "../../components/associationBox/AssociationBox";
import VoidSpace from "../../components/voidSpace/VoidSpace";
import CardEvent from "../../components/cardEvent/CardEvent";
import SearchInput from "../../components/searchInput/SearchInput";

//Funzioni o import da librerie
import { setGlobalState } from "../../utils/state";
import { getExploreEventsWS } from "./api/exploreAPI";
import { isEmpty } from "../../utils/validation";
import { Row, Col, Button } from "react-bootstrap";
import { t } from "i18next";
import { useScreenSize } from "../../ScreenSizeContext";

const Explore = () => {
  const isPC = useScreenSize();

  const [search, setSearch] = useState("");
  const [openFilter, setOpenFilter] = useState(false);
  const [listEvent, setListEvent] = useState([]);
  const [filterListEvent, setFilterListEvent] = useState([]);
  const [limit, setLimit] = useState(50);

  useEffect(() => {
    setGlobalState("selectedIdBottomBar", 3);

    console.log(limit);

    getExploreEventsWS({ limit })
      .then((res) => {
        setListEvent(res);
        setFilterListEvent(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [limit]);

  const searchFunction = () => {
    if (!isEmpty(search)) {
      setFilterListEvent(
        listEvent.filter((event) => {
          const name = event.name?.toLowerCase() || "";
          const address = event.address?.toLowerCase() || "";
          const assocName = event.info_association?.name?.toLowerCase() || "";

          return (
            name.includes(search.toLowerCase()) ||
            address.includes(search.toLowerCase()) ||
            assocName.includes(search.toLowerCase())
          );
        })
      );
    } else {
      setFilterListEvent(listEvent);
    }
  };

  return (
    <>
      <HeaderBar
        title={!isPC ? t("common.name_application") : t("common.explore")}
      />
      <div className="explore-container">
        <div className="container-responsive">
          <div className="header-content">
            <SearchInput
              search={search}
              setSearch={setSearch}
              searchFunction={searchFunction}
            />
            <div className="paragraph">
              <div className="title">
                {t("explore.start_adventure").toUpperCase()}
              </div>
              <div className="subtitle">
                {t("explore.opportunity_near_you").toUpperCase()}
              </div>
            </div>
          </div>
          <AssociationBox
            title={t("home.near_association")}
            type={2}
            linkColor={"#000"}
          />
          <div className="list-event">
            <div className="title">{t("explore.could_like_it")}</div>
            <Row sm={1} md={1} lg={2} xl={3} className="g-2">
              {!isEmpty(filterListEvent)
                ? filterListEvent.map((item) => (
                    <Col sm={12} md={12} lg={6} xl={4} key={item.id}>
                      <CardEvent
                        id={item.id}
                        title={item.name}
                        eventAddress={item.address}
                        startDatetime={item.start_date}
                        photo={item.photo[0]}
                        isLike={item.is_like}
                        numberLike={item.number_like}
                        associationName={item.info_association.name}
                      />
                    </Col>
                  ))
                : null}
            </Row>
            {!isEmpty(filterListEvent) ? (
              <div className="w-100 d-flex justify-content-center align-items-center mt-3">
                <Button
                  style={{ borderRadius: 10 }}
                  size="sm"
                  variant="info"
                  onClick={() => setLimit(limit + 25)}
                >
                  {t("common.view_more")}
                </Button>
              </div>
            ) : null}
          </div>
          <VoidSpace />
        </div>
      </div>
      {openFilter && (
        <>
          <div className="filter-box-container">
            <div onClick={() => setOpenFilter(false)}>X</div>
          </div>
        </>
      )}
    </>
  );
};

export default Explore;
